import styled, { keyframes } from "styled-components";
import { colors, font, radius } from "../../../styles/theme/tokens";

const pop = keyframes`
  0% { transform: scale(0.3) translateY(40px); opacity: 0; }
  70% { transform: scale(1.08) translateY(-6px); opacity: 1; }
  100% { transform: scale(1) translateY(0); }
`;

const rise = keyframes`
  from { transform: translateY(12px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

export const About = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const AboutMascot = styled.div`
  position: absolute;
  top: -20px;
  left: 10px;
  width: 130px;
  transform: rotate(-10deg);

  svg {
    display: block;
    width: 100%;
  }
`;

export const AboutCard = styled.div`
  width: 100%;
  max-width: 1000px;
  padding: 48px 64px;
  border-radius: ${radius.xl};
  background: ${colors.pinkSoft};
  font-family: ${font.text};
  font-size: 31px;
  line-height: 1.5;
  text-align: center;
  color: ${colors.ink};
  animation: ${rise} 0.4s ease-out;

  p {
    margin: 0 0 18px;
  }
  p:last-child {
    margin-bottom: 0;
  }
  em {
    font-weight: 800;
    font-style: italic;
    color: ${colors.brandDeep};
  }
`;

export const Rating = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 28px;
  height: 100%;
`;

export const Stars = styled.div`
  display: flex;
  gap: 18px;
`;

export const Star = styled.button`
  font-size: 96px;
  line-height: 1;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  color: ${(props) => (props.$on ? colors.amber : "#D9D6F0")};
  transform: scale(${(props) => (props.$on ? 1.08 : 1)});
  transition: color 0.15s ease, transform 0.15s ease;
`;

export const Thanks = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  animation: ${pop} 0.6s ease-out;

  img {
    height: 230px;
  }
`;

export const Bubble = styled.div`
  padding: 18px 30px;
  border-radius: ${radius.xl};
  background: ${(props) => (props.$sad ? colors.brandSoft : colors.successSoft)};
  font-family: ${font.text};
  font-size: 44px;
  font-weight: 800;
  color: ${(props) => (props.$sad ? colors.brandDeep : colors.success)};
`;

export const Small = styled.div`
  font-family: ${font.text};
  font-size: 34px;
  font-weight: 800;
  color: ${colors.brandDeep};
  animation: ${rise} 0.3s ease-out;
`;
